export type InstallPlatform = 'ios' | 'android' | 'harmony';
export type InstallStepIcon = 'share' | 'menu' | 'grid' | 'home' | 'check';
type PlatformGuide = {
  label: string;
  hint: string;
  steps: Array<{ icon: InstallStepIcon; title: string; text: string }>;
  tip: string;
};

export const INSTALL_PLATFORMS: Record<InstallPlatform, PlatformGuide> = {
  ios: {
    label: 'iPhone', hint: '先用 Safari 打开，再添加到主屏幕',
    steps: [
      { icon: 'share', title: '点「分享」按钮', text: '在 Safari 中找到分享图标或「共享」' },
      { icon: 'home', title: '选「添加到主屏幕」', text: '向下滑动分享菜单，找到这项操作' },
      { icon: 'check', title: '点「添加」完成', text: '保留名称「练刻」，确认后返回桌面' },
    ],
    tip: '若有「作为网页 App 打开」开关，请开启后再添加。找不到添加项时，可在「编辑操作」中查找。',
  },
  android: {
    label: '安卓', hint: '先用系统浏览器打开，再添加到桌面',
    steps: [
      { icon: 'menu', title: '打开浏览器菜单', text: '在小米等系统浏览器中，找到菜单按钮' },
      { icon: 'home', title: '选「添加到桌面」', text: '也可能叫「添加至」或「安装应用」' },
      { icon: 'check', title: '确认添加', text: '按提示允许添加，返回桌面查看图标' },
    ],
    tip: '不同机型的菜单名称可能不同。若找不到添加选项，可先复制链接，用系统浏览器重新打开。',
  },
  harmony: {
    label: '鸿蒙', hint: '先用华为浏览器打开，再添加到桌面',
    steps: [
      { icon: 'grid', title: '点浏览器菜单按钮', text: '在华为浏览器中打开练刻，找到菜单' },
      { icon: 'home', title: '选「添加至桌面」', text: '旧版系统：选「添加至」→「桌面」' },
      { icon: 'check', title: '确认添加', text: '返回桌面，点击「练刻」图标即可进入' },
    ],
    tip: '保留名称「练刻」，点击勾选按钮确认。不同鸿蒙版本的菜单名称可能略有差异。',
  },
};
